import ImportsPage from './ImportsPage';
import { reducer as importsPageReducer } from './model';
export default ImportsPage;
export { importsPageReducer };
